import axios from "axios";
import Config from "../utils/Config";
import helpers from "../utils/Helpers";

class PolicyService {
  getAuthHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("trp_tk")}`,
      },
    };
  }

  async createPolicy(payload) {
    try {
      const response = await axios.post(
        `${Config.apiUrl}/provider/policy/create`,
        payload,
        this.getAuthHeaders()
      );
      return helpers.handleApiSuccess(response, "Policy created successfully");
    } catch (error) {
      return helpers.handleApiError(
        error,
        "An error occurred while creating policy"
      );
    }
  }

  async getAllPolicies(
    short_description = null,
    policy_type = null
  ) {
    try {
      // Build endpoint based on provided filters
      let endpoint;
      
      if (short_description && policy_type) {
        // Fetch policies by insurance type and policy type
        endpoint = `${Config.apiUrl}/provider/policy/get/${short_description}/${policy_type}`;
      } else if (short_description) {
        // Fetch all policies of a specific insurance type
        endpoint = `${Config.apiUrl}/provider/policy/get/${short_description}`;
      } else {
        // Fetch all policies (no filters)
        endpoint = `${Config.apiUrl}/provider/policy/get`;
      }
      
      const response = await axios.get(
        endpoint,
        this.getAuthHeaders()
      );
      return {
        status: true,
        message:
          response.data.data?.reason || "All policies fetched successfully",
        data: response.data,
      };
    } catch (error) {
      return {
        status: false,
        message:
          error.response?.data?.data?.reason ||
          "An error occurred while getting all policies",
        data: null,
      };
    }
  }

  async getPolicy(policy_slug) {
    try {
      const response = await axios.get(
        `${Config.apiUrl}/show/policy/${policy_slug}`,
        this.getAuthHeaders()
      );
      return helpers.handleApiSuccess(response, "Policy fetched successfully");
    } catch (error) {
      return helpers.handleApiError(
        error,
        "An error occurred while fetching policy"
      );
    }
  }

  async updatePolicy(payload, policy_slug) {
    try {
      const response = await axios.post(
        `${Config.apiUrl}/provider/policy/update/${policy_slug}`,
        payload,
        this.getAuthHeaders()
      );
      return helpers.handleApiSuccess(response, "Policy updated successfully");
    } catch (error) {
      return helpers.handleApiError(
        error,
        "An error occurred while updating policy"
      );
    }
  }

  async deletePolicy(policy_slug) {
    try {
      const response = await axios.post(
        `${Config.apiUrl}/provider/policy/delete/${policy_slug}`,
        {},
        this.getAuthHeaders()
      );

      return helpers.handleApiSuccess(response, "Policy deleted successfully");
    } catch (error) {
      return helpers.handleApiError(
        error,
        "An error occurred while deleting policy"
      );
    }
  }
}

const policyService = new PolicyService();
export default policyService;
